export default "__VITE_ASSET__916a88d7__"